@if (isMobile && router.url.includes('iniciar')) {
<div [ngClass]="themeClass" class="main inicial-main" translate="no">
  <div class="inicial-div">
    <div class="logo" style="padding-bottom: 60px;">
      <img class="imglogo" [src]="'data:image/jpeg;base64,' + urlFoto" [alt]="alt" [width]="width" [height]="height">
      <!--<img src="assets/NovoLogoSalaSituacao.png" (click)="retornoParaHome()" width="200">-->
    </div>
    <div class="logo" style="padding-bottom: 60px;">
      <img src="assets/poupatempo_indicadoreslogo_partida_modificada.png" (click)="retornoParaHome()" width="200">
    </div>
    <div class="sub-main" style="display: flex; justify-content: right;">
      <div style="display: flex; justify-content: right; align-items: center;">
        @if(CiberarkStatus)
        {
            <button (click)="irParaMinhaArea()" class="btn_govbr">
              @if (login == null || login== undefined) {
              <i class="fad fa-user" style="margin-right: 10px;--fa-secondary-opacity: 1;"></i> Ir para o Minha Area
              }
              @else
              {
              <i class="fa fa-sign-in" aria-hidden="true" style="margin-right: 10px;"></i> Entrar Sala de Situação
              }
            </button>
        }
        @else{
          <button (click)="loginGovBr()" class="btn_govbr">
            @if (login == null || login== undefined) {
            <i class="fad fa-user" style="margin-right: 10px;--fa-secondary-opacity: 1;"></i> Entrar com o gov.br
            }
            @else
            {
            <i class="fa fa-sign-in" aria-hidden="true" style="margin-right: 10px;"></i> Entrar Sala de Situação
            }
          </button>
        }

      </div>
    </div>
  </div>
</div>
}
@else{
@if (!ModoApresentacao) {
@if (isMobile) {
<div [ngClass]="themeClass" class="main" translate="no">
  <div class="sub-main" style="display: flex; justify-content: space-around; align-items: center;padding-bottom: 10px;">
    <div>
      <div class="logo-1-2">
        <div class="logo">
          <img class="imglogo" [src]="'data:image/jpeg;base64,' + urlFoto" [alt]="alt" width="100vw">

          <!--<img src="assets/NovoLogoSalaSituacao.png" (click)="retornoParaHome()" width="">-->
        </div>
        <div class="logo">
          <img src="assets/poupatempo_indicadoreslogo_partida_modificada.png" (click)="retornoParaHome()" width="100vw">
        </div>
      </div>
    </div>
  </div>
  <div class="sub-main" style="display: flex; justify-content: right;">


    <div style="display: flex; justify-content: right; align-items: center;">
      @if (login == null || login== undefined) {
      @if(CiberarkStatus)
      {
        <button (click)="irParaMinhaArea()" class="btn_govbr"> <i class="fad fa-user"
          style="margin-right: 10px;--fa-secondary-opacity: 1;"></i> Ir para o Minha Area</button>
      }
      @else{
      <button (click)="loginGovBr()" class="btn_govbr"> <i class="fad fa-user"
          style="margin-right: 10px;--fa-secondary-opacity: 1;"></i> Entrar com o gov.br</button>
      }
      }
      @else{
      <div style="display: flex; justify-content: right; align-items: center;">
        <button (click)="AbrirAlertasExclamacao()"
          [ngStyle]="{'background': numeroAlertasExclamacao != 0 ? '#da1313f3' : '#9e9e9e'}"
          style="margin-left: 10px;margin-right: 5px;" class="btnNotificacao" type="button" aria-label="Notificações">
          <i data-feather="bell" aria-hidden="true" focusable="false" style="color: #fff;"
            class="far fa-exclamation fa-lg"></i>
          <small
            [ngStyle]="{'background-color': numeroAlertasExclamacao != 0 ? '#d80b0b' : '#9e9e9e'}">{{numeroAlertasExclamacao}}<ng-container
              *ngIf="numeroAlertasExclamacao!=0">+</ng-container></small>
        </button>
        <button (click)="AbrirAlertas()" [ngStyle]="{'background': numeroAlertas != 0 ? '#da1313f3' : '#9e9e9e'}"
          style="margin-left: 10px;margin-right: 5px;" class="btnNotificacao" type="button" aria-label="Notificações">
          <i data-feather="bell" aria-hidden="true" focusable="false" style="color: #fff;"
            class="far fa-bell fa-lg"></i>
          <small
            [ngStyle]="{'background-color': numeroAlertas != 0 ? '#d80b0b' : '#9e9e9e'}">{{numeroAlertas}}<ng-container
              *ngIf="numeroAlertas!=0">+</ng-container></small>
        </button>
        <div class="container">
          <!-- Btn-->
          <button class="btn_3"><span style="margin-left: 20px;">{{login}}</span>
            <ul class="dropdown">
              <!--<li class="active"><a href="#">Profile Information</a></li>
              <li><a href="#">Help</a></li>-->

              <li>
                <p>Modo da tela:</p>
                <div style="display: flex;">
                  <button [ngClass]="VisualizacaoPadrao === 'DARK' ? '' : 'btn-2'"
                    style="width: 100%; border: 2px solid #9e9e9e;" (click)="AlterarModoTela('DARK')">
                    <p>Dark</p>
                  </button>
                  <button [ngClass]="VisualizacaoPadrao === 'LIGHT' ? '' : 'btn-2'"
                    style="width: 100%; border: 2px solid #9e9e9e;" (click)="AlterarModoTela('LIGHT')">
                    <p>Light</p>
                  </button>
                </div>
              </li>
              <li><a (click)="deslogar()">Sair</a></li>
            </ul>
          </button>
        </div>

      </div>
      }
    </div>
  </div>
</div>
}
@else{
<div [ngClass]="themeClass" class="main" translate="no">
  <div class="sub-main">
    <div class="logo-1-2">
      <div class="logo">
        <img class="imglogo" [src]="'data:image/jpeg;base64,' + urlFoto" [alt]="alt" [width]="width" [height]="height">
      </div>
      <div class="logo">
        <img class="imagem" src="assets/poupatempo_indicadoreslogo_partida_modificada.png" (click)="retornoParaHome()"
          width="200">
      </div>
    </div>


    <div style="display: flex; justify-content: normal; align-items: end;">
      @if (login == null || login== undefined) {
        @if(CiberarkStatus)
        {
          <button (click)="irParaMinhaArea()" class="btn_govbr"> <i class="fad fa-user"
            style="margin-right: 10px;--fa-secondary-opacity: 1;"></i> Ir para o Minha Area</button>
        }
        @else{
        <button (click)="loginGovBr()" class="btn_govbr"> <i class="fad fa-user"
            style="margin-right: 10px;--fa-secondary-opacity: 1;"></i> Entrar com o gov.br</button>
        }
      }
      @else{
      <div style="display: flex; justify-content: normal; align-items: center;">
        <button (click)="AbrirAlertasExclamacao()"
          [ngStyle]="{'background': numeroAlertasExclamacao != 0 ? '#da1313f3' : '#9e9e9e'}"
          style="margin-left: 10px;margin-right: 5px;" class="btnNotificacao" type="button" aria-label="Notificações">
          <i data-feather="bell" aria-hidden="true" focusable="false" style="color: #fff;"
            class="far fa-exclamation fa-lg"></i>
          <small
            [ngStyle]="{'background-color': numeroAlertasExclamacao != 0 ? '#d80b0b' : '#9e9e9e'}">{{numeroAlertasExclamacao}}<ng-container
              *ngIf="numeroAlertasExclamacao!=0">+</ng-container></small>
        </button>
        <button (click)="AbrirAlertas()" [ngStyle]="{'background': numeroAlertas != 0 ? '#da1313f3' : '#9e9e9e'}"
          style="margin-left: 10px;margin-right: 5px;" class="btnNotificacao" type="button" aria-label="Notificações">
          <i data-feather="bell" aria-hidden="true" focusable="false" style="color: #fff;"
            class="far fa-bell fa-lg"></i>
          <small
            [ngStyle]="{'background-color': numeroAlertas != 0 ? '#d80b0b' : '#9e9e9e'}">{{numeroAlertas}}<ng-container
              *ngIf="numeroAlertas!=0">+</ng-container></small>
        </button>
        <div class="container">
          <!-- Btn-->
          <button class="btn_3"><span style="margin-left: 20px;">{{login}}</span>
            <ul class="dropdown">
              <!--<li class="active"><a href="#">Profile Information</a></li>
            <li><a href="#">Help</a></li>-->

              <li>
                <p>Modo da tela:</p>
                <div style="display: flex;">
                  <button [ngClass]="VisualizacaoPadrao === 'DARK' ? '' : 'btn-2'"
                    style="width: 100%; border: 2px solid #9e9e9e;" (click)="AlterarModoTela('DARK')">
                    <p>Dark</p>
                  </button>
                  <button [ngClass]="VisualizacaoPadrao === 'LIGHT' ? '' : 'btn-2'"
                    style="width: 100%; border: 2px solid #9e9e9e;" (click)="AlterarModoTela('LIGHT')">
                    <p>Light</p>
                  </button>
                </div>
              </li>
              <li><a (click)="deslogar()">Sair</a></li>
            </ul>
          </button>
        </div>

      </div>
      }
    </div>
  </div>
</div>
}
}
<app-alerta-vagas *ngIf="!router.url.includes('iniciar') && !router.url.includes('loading')"
  [DadosAlerta]="listaInd"></app-alerta-vagas>



<div *ngIf="usuarioInativo" class="alert alert-danger" style="text-align: center;" translate="no">
  Usuário inativo. Entre em contato com o administrador.
</div>
}
<!-- </div> -->